/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { TextField, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { selectCurrentUserApiToken, selectCurrentUserId } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import axiosInstance from '../functions/axiosInstance';
import AlertModal from "./AlertModal";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const createNewInvestigation = async (navigate, dispatch, apiToken, setAlertModalState, title, description, openToJoin) => {
  if (title) {
    dispatch(globalLoadingOn());
    let response = await axiosInstance({
      method: 'POST',
      url: fevir_node_server_address,
      timeout: 120000,
      data: {
        'functionid': 'createnewinvestigation',
        'title': title,
        'description': description,
        'opentojoin': openToJoin,
        'apiToken': apiToken
      },
    }).then((resp) => {
      if (resp?.data) {
        return resp.data;
      }
      console.log("NO RESPONSE from getallfeedback call");
    }).catch((error) => { console.log(error); });
    dispatch(globalLoadingOff());
    if (response?.success && response.investid) {
      navigate("/radar/" + response.investid);
    } else {
      setAlertModalState(prevState => {
        return {
          ...prevState,
          "open": true,
          "header": "Error",
          "content": "Not successful in creating a new investigation. Please contact FEvIR admins."
        };
      });
    }
  } else {
    setAlertModalState(prevState => {
      return {
        ...prevState,
        "open": true,
        "header": "",
        "content": "Please enter a title of the investigation."
      };
    });
  }
}

// eslint-disable-next-line no-empty-pattern
const MeasuringTheRateCreationPage = ({ }) => {
  const apiToken = useSelector(selectCurrentUserApiToken);
  const userId = useSelector(selectCurrentUserId);
  const isLoggedIn = (!!userId && userId !== "1");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [investigationTitle, setInvestigationTitle] = useState("");
  const [investigationDescription, setInvestigationDescription] = useState("");
  const [openToJoin, setOpenToJoin] = useState(true);

  const [alertModalState, setAlertModalState] = useState({
    open: false, alertHistory: [], header: "", content: ""
  });

  useEffect(() => {
    dispatch(changeBrowserTabTitle("FEvIR RADAR Tool"));
    dispatch(changeTool("FEvIR®: RADAR Tool"));
  }, []);

  return <div>
    <AlertModal alertModalState={alertModalState} setAlertModalState={setAlertModalState} />
    <Segment className={`containerSegment measuringTheRateSegment maxRemainderOfPageSegment`} raised>
      <h3>Create a new investigation</h3>
      <br />
      <TextField style={{ width: "70%" }} className="inputField" type='text' label={'Investigation Title'} size="small" variant='outlined' value={investigationTitle} onChange={(e) => { setInvestigationTitle(e.target.value); }} />
      <br />
      <br />
      <TextField style={{ width: "70%" }} multiline className="inputField" type='text' label={'Description'} size="small" variant='outlined' value={investigationDescription} onChange={(e) => { setInvestigationDescription(e.target.value); }} />
      <br />
      <FormGroup style={{ width: "320px" }}>
        <FormControlLabel control={<Checkbox size="medium" checked={openToJoin} onChange={(e) => { setOpenToJoin(e.target.checked); }} />} label="Open for anyone to join the investigation?" />
      </FormGroup>
      <br />
      {isLoggedIn ?  /* The loading userState check so that the button doesn't flash into existance after loading. */
        <Button color='green' /*  "color": "#000000", */
          style={{ width: "280px", float: "left" }}
          content="Start New Investigation"
          onClick={() => { createNewInvestigation(navigate, dispatch, apiToken, setAlertModalState, investigationTitle, investigationDescription, openToJoin); }}
        />
        :
        <>Please login to create a measuring the rate investigation.</>
      }
    </Segment>

  </div>
};

export default MeasuringTheRateCreationPage;